import axios from "axios";


export function getAjax(url, lang){ // handles get requests
    const apiLanguage = lang && lang !== "*"
        ? lang.split(",", 1)[0].split(";", 1)[0].replace("_", "-").split("-", 1)[0]
        : lang;

    return axios.get(url, {
        headers: {
          'Accept-Language': apiLanguage
        }
      }).then((result)=>{
        return result.data;
    }).catch(e=>{
        if(e.response){
            if(e.response.status === 400){
                window.location.href = process.env.PUBLIC_URL + '/feedback/400';
                return false;
            }else{
                window.location.href = process.env.PUBLIC_URL + '/feedback/500';
                return false;
            }
        }else{
            window.location.href = process.env.PUBLIC_URL + '/feedback/500';
            return false;
        }
    });
}

export function postAjax(url, data, config){  // handles post requests
    return axios.post(url, data, config).then((result)=>{
        return result.data;
    })
}